import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Save, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const STATUS = {
  scaduto: { row: "bg-red-50 border-red-200", text: "text-red-700", label: (d) => `Scaduto da ${-d} gg` },
  in_scadenza: { row: "bg-orange-50 border-orange-200", text: "text-orange-700", label: (d) => (d === 0 ? "Scade oggi" : `Scade tra ${d} gg`) },
  ok: { row: "bg-card border-border", text: "text-emerald-700", label: (d) => `Tra ${d} gg` },
};

function ExpiryRow({ e, i, onSaved }) {
  const [date, setDate] = useState(e.expiry);
  const st = STATUS[e.status];
  const save = async (expiry) => {
    try {
      await api.put("/expiries", { vehicle_id: e.vehicle_id, item_id: e.item_id, expiry });
      toast.success(expiry ? "Scadenza aggiornata" : "Scadenza rimossa");
      onSaved();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Errore");
    }
  };
  return (
    <div data-testid={`expiry-row-${i}`} className={`flex flex-wrap items-center justify-between gap-3 rounded-lg border px-4 py-3 ${st.row}`}>
      <div className="min-w-0">
        <p className="font-semibold text-sm">{e.item_name}</p>
        <p className="text-xs text-muted-foreground">{e.vehicle_name} · agg. da {e.updated_by_name}</p>
      </div>
      <div className="flex items-center gap-2">
        <span className={`text-xs font-bold ${st.text}`} data-testid={`expiry-status-${i}`}>{st.label(e.days_left)}</span>
        <Input type="date" value={date} onChange={(ev) => setDate(ev.target.value)} data-testid={`expiry-date-${i}`} className="h-8 w-40 text-sm bg-white" />
        <Button size="icon" variant="ghost" title="Salva" onClick={() => save(date)} disabled={!date || date === e.expiry} data-testid={`expiry-save-${i}`} className="h-8 w-8"><Save className="h-4 w-4" /></Button>
        <Button size="icon" variant="ghost" title="Rimuovi" onClick={() => save(null)} data-testid={`expiry-delete-${i}`} className="h-8 w-8 text-destructive"><Trash2 className="h-4 w-4" /></Button>
      </div>
    </div>
  );
}

export function ChecklistExpiries({ kind = "vano" }) {
  const [vehicles, setVehicles] = useState([]);
  const [vehicleId, setVehicleId] = useState("");
  const [list, setList] = useState([]);
  const [tick, setTick] = useState(0);

  useEffect(() => { api.get("/vehicles").then((r) => setVehicles(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    api.get("/expiries", { params: vehicleId ? { vehicle_id: vehicleId } : {} }).then((r) => setList(r.data.filter((e) => e.kind === kind))).catch(() => setList([]));
  }, [vehicleId, tick, kind]);

  return (
    <div className="space-y-4" data-testid="expiries-view">
      <div className="flex flex-wrap items-end gap-4 rounded-xl border border-border bg-card p-4">
        <div className="space-y-1 w-64">
          <Label>Ambulanza</Label>
          <Select value={vehicleId || "all"} onValueChange={(v) => setVehicleId(v === "all" ? "" : v)}>
            <SelectTrigger data-testid="expiry-filter-vehicle"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tutte</SelectItem>
              {vehicles.map((v) => <SelectItem key={v.id} value={v.id}>{v.name}{v.plate ? ` (${v.plate})` : ""}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <p className="text-xs text-muted-foreground">Le date si inseriscono compilando la check-list (voci con scadenza) e si possono correggere qui.</p>
      </div>
      {list.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="expiries-empty">Nessuna scadenza registrata.</p>
      ) : list.map((e, i) => <ExpiryRow key={`${e.vehicle_id}-${e.item_id}-${e.expiry}`} e={e} i={i} onSaved={() => setTick((t) => t + 1)} />)}
    </div>
  );
}
